import { TextField } from '@material-ui/core';
import React, { FunctionComponent } from 'react';

import Texto from '@infotrack/presentacion-componentes/texto';

import IDocumentoFiltro from 'Infotrack@Modelos/negocioRefactor/entidades/consulta/documento/IDocumentoFiltro';

interface ICampoDocumentoRelacionadoProps {
    manejarCambioFiltro: (
        nombreFiltro: keyof IDocumentoFiltro,
        nuevoValor: IDocumentoFiltro[keyof IDocumentoFiltro]
    ) => any;
    valor: string;
}

const CampoDocumentoRelacionado: FunctionComponent<ICampoDocumentoRelacionadoProps> = ({
    manejarCambioFiltro,
    valor,
}) => (
    <TextField
        fullWidth
        label={<Texto id="Documentos.CampoDocumentoRelacionado.Nombre" />}
        onChange={(event) => manejarCambioFiltro('DocumentoRelacionado', event.target.value)}
        value={valor}
    />
);

export default CampoDocumentoRelacionado;
